<script>
import {defineComponent} from 'vue';
import ShelterFloatButton from "@/components/shelter/ShelterFloatButton.vue";

export default defineComponent({
    name: 'AppLayoutUser',
    components: {ShelterFloatButton},
    computed: {
        showNewPlatformNotice() {
            return this.$store.me.is_teacher
                && ['1', '2', '3', '4', '7', '8', '9'].includes(String(this.$store.class?.course?.level));
        },
    },
})
</script>

<template>
    <main class="wrapper">
        <kmm-nav-defense v-if="$store.isDefense" />
        <kmm-nav v-else />

        <section v-if="showNewPlatformNotice" class="new-platform-notice">
            <a href="https://edprofi.net" class="new-platform-notice__button">
                Перехід на нову платформу
            </a>
            <small class="new-platform-notice__text">
                Для авторизації на новій платформі використовуйте свій діючий (старий) ключ доступу.
                Якщо старий ключ не діє, для отримання нового ключа звертайтесь за телефоном: +380996800900, +380976800900
            </small>
        </section>

        <slot />
        <ShelterFloatButton />
    </main>
</template>

<style scoped>
.new-platform-notice {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    margin: 12px auto;
    padding: 0 16px;
    text-align: center;
}

.new-platform-notice__button {
    display: inline-flex;
    justify-content: center;
    padding: 10px 18px;
    border-radius: 8px;
    background: #ce00ff;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.2s ease;
}

.new-platform-notice__button:visited {
    color: #fff;
}

.new-platform-notice__button:hover,
.new-platform-notice__button:focus,
.new-platform-notice__button:active {
    background: #a900d1;
    color: #fff;
    text-decoration: none;
}

.new-platform-notice__text {
    max-width: 760px;
    color: #59616a;
    font-size: 12px;
    line-height: 1.4;
}
</style>
